import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import type { UseApproveUnlockDialog } from "@/@types/unlock-request";
import { UNLOCK_COMMENT_MAX_LENGTH } from "@/constants/access-request";
import { UNLOCK_DETAIL_LABELS } from "@/constants/messages";
import { UNLOCK_CONFIRM_APPROVE_TEST_ID } from "@/constants/unlock-request";

interface ApproveUnlockDialogProps {
  approval: UseApproveUnlockDialog;
  description: string;
}

export function ApproveUnlockDialog({
  approval,
  description,
}: ApproveUnlockDialogProps): JSX.Element {
  const { form, isConfirmOpen, isApproving, changeConfirmOpen, confirm } =
    approval;

  return (
    <AlertDialog open={isConfirmOpen} onOpenChange={changeConfirmOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{UNLOCK_DETAIL_LABELS.CONFIRM_TITLE}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>

        <Form {...form}>
          <form onSubmit={confirm} className="space-y-4">
            <FormField
              control={form.control}
              name="comment"
              render={({ field }) => (
                <FormItem>
                  <FormLabel htmlFor="unlock-approve-comment">
                    {UNLOCK_DETAIL_LABELS.CONFIRM_COMMENT}
                  </FormLabel>
                  <FormControl>
                    <Textarea
                      {...field}
                      id="unlock-approve-comment"
                      maxLength={UNLOCK_COMMENT_MAX_LENGTH}
                      placeholder={
                        UNLOCK_DETAIL_LABELS.CONFIRM_COMMENT_PLACEHOLDER
                      }
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <AlertDialogFooter>
              <Button
                type="button"
                variant="ghost"
                disabled={isApproving}
                onClick={() => changeConfirmOpen(false)}
              >
                {UNLOCK_DETAIL_LABELS.CONFIRM_CANCEL}
              </Button>
              <Button
                type="submit"
                data-testid={UNLOCK_CONFIRM_APPROVE_TEST_ID}
                disabled={isApproving}
              >
                {UNLOCK_DETAIL_LABELS.CONFIRM_ACTION}
              </Button>
            </AlertDialogFooter>
          </form>
        </Form>
      </AlertDialogContent>
    </AlertDialog>
  );
}
